// --------------------------------------------------------
// QUESTIONNAIRE ANSWERS - QuestionnaireEletronic
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import ArrowRight from "../../../../assets/imgs/arrow-right.svg";
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react'
import { H1, Text } from '../../../../components/UI/generalLayout/Layout.styled'
import { PersonService } from '../../../../core/http/service/PersonService'
import { Paths } from "../../../../enums/Paths";
import { useNavigate } from "react-router-dom";
import { CircularProgress, ClickAwayListener } from "@mui/material";
import { useSelector } from "react-redux";
import DetailsAttendanceRecordAccordion from "./DetailsAttendanceRecordAccordion";
import { OutlinedUpdateButton } from "../../../../components/UI/buttons/Button.styled";
import { Update } from "@mui/icons-material";
import { BiLinkExternal } from "react-icons/bi";
import ClinicFrameConfiguracaoService from "../../../../core/http/service/ClinicFrameConfiguracaoService";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// QUESTIONNAIRE ANSWERS INTERFACE
// --------------------------------------------------------

interface IQuestionnaireEletronic {
    pessoa: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const QuestionnaireEletronic = ({ pessoa }: IQuestionnaireEletronic) => {
    // --------------------------------------------------------
    // QUESTIONNAIRE ANSWERS PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [clinicFrameConfig, setClinicFrameConfig] = useState<any>(null)
    const [avaliacoes, setAvaliacoes] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const navigate = useNavigate();
    const { currentProfile }: any = useSelector((state: any) => state.login);

    const fetchAvaliacoes = useCallback(async () => {

        try {
            setIsLoading(true)
            const service: PersonService = new PersonService();
            const idOms = '801bea09-a642-4711-a12a-a6d9e7930e28';
            const idHmv = '564d7778-7643-4401-979e-40e49f35c2e3';
            const targetPessoaId = pessoa?.idPessoa || pessoa?.id;
            if (!targetPessoaId) {
                setIsLoading(false);
                return;
            }
            const respostas: any[] = [];
            const resultOMS: any = await service.getAvaliacaoByPessoaId(idOms, targetPessoaId);
            const resultHMV: any = await service.getAvaliacaoByPessoaId(idHmv, targetPessoaId);
            const answersOMS: any[] = resultOMS?.data?.data || [];
            const answersHMV: any[] = resultHMV?.data?.data || [];
            answersOMS.forEach(r => {
                respostas.push({ ...r, questionario: 'oms' })
            })
            answersHMV.forEach(r => {
                respostas.push({ ...r, questionario: 'hmv' })
            })
            const sortFunction = (a: any, b: any) => {
                return moment(a.dataInclusao) > moment(b.dataInclusao) ? -1 : 1;
            }
            setAvaliacoes(respostas.sort(sortFunction))
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }

    }, [pessoa])

    useEffect(() => {
        const savedCompanyStr = localStorage.getItem('currentCompany');
        if (savedCompanyStr) {
            const savedCompany = JSON.parse(savedCompanyStr);
            if (savedCompany.usaClinicFrame) {
                ClinicFrameConfiguracaoService.getConfiguracao(savedCompany.id).then((resp: any) => {
                    if (resp.data && resp.data.data) {
                        setClinicFrameConfig(resp.data.data);
                    }
                });
            }
        }
        fetchAvaliacoes();
    }, [])

    const onNavigateAnswer = (id: string, isHMV: boolean) => {
        const path = isHMV ? Paths.HMVQuestionnaire : Paths.OMSQuestionnaire;
        navigate(path, { state: { isView: true, pessoaResposta: pessoa, avaliacaoId: id } })
    }
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <H1>Receituário Eletrônico</H1>
            {isLoading ? (<div style={{ textAlign: 'center', height: 50, marginTop: 100, width: '100%' }}>
                <CircularProgress />
            </div>) : (<>
                <DetailsAttendanceRecordAccordion
                    name={"Receituário"}
                    isCollapsable={false}
                >
                    <div>
                        <OutlinedUpdateButton 
                            isMobile={false} 
                            style={{ height: 20, width: 250, marginTop: 20 }} 
                            onClick={() => {
                                if (clinicFrameConfig) {
                                    const url = clinicFrameConfig.url;
                                    const params = clinicFrameConfig.urlParamsReceituario || "p=H";
                                    window.open(`${url}${url.includes('?') ? '&' : '?'}${params}`, '_blank');
                                }
                            }}
                        >
                            <BiLinkExternal />
                            Receituário Eletrônico
                        </OutlinedUpdateButton>
                    </div>
                </DetailsAttendanceRecordAccordion>

            </>)}
            {(avaliacoes && avaliacoes.length === 0 && !isLoading) && (<Text>Nenhum resultado encontrado</Text>)}

        </>
    )
    // --------------------------------------------------------
}

export default QuestionnaireEletronic